
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import ArticleCadPreview from "@/components/ArticleCadPreview.vue";
import { CustomerOrderDto } from "../../dtos/customerOrderDto";
import { ErpCustomerOrderState } from "../../dtos/erpCustomerOrderState";
import { CustomerOrderPositionDto } from "@/dtos/customerOrderPositionDto";
import { PriceModel } from "@/dtos/priceModel";
import { PartDto } from "@/dtos/partDto";

@Component({
	components: {
		ArticleCadPreview,
	},
})
export default class CustomerDashboard extends Vue {
	@Prop()
	private orderId!: string;
	private order: CustomerOrderDto | null = null;
	private loading: boolean = false;
	private loadingKommission: boolean = false;
	private hasChanges: boolean = false;
	private addDialog: boolean = false;
	private gefilterteArtikel: any = [];
	private articleFilter: string = "";
	private selectedArticle: any = null;
	private menge: number = 1;
	private price: string = "";
	private selectedPriceModel: string = "";
	private priceInfoUpdateInfo: string = "";
	private positionHeader: Array<{
		text: string;
		value: string;
		align: string;
		sortable: boolean;
		width: string;
	}> = Array(
		{
			text: "Pos",
			value: "position",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Artikel Id",
			value: "customerId",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "",
			value: "",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Bezeichnung",
			value: "companyName",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Menge",
			value: "surname",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Preis",
			value: "name",
			align: "right",
			sortable: false,
			width: "1px",
		},
		{
			text: "Total",
			value: "",
			align: "right",
			sortable: false,
			width: "1px",
		}
	);

	private mounted() {
		this.loadOrder().then(() => {
			if (this.order) {
				this.selectedPriceModel = PriceModel[this.order.priceModel];
			}
		});
	}

	private isSubposition(position: any) {
		var parentPosition = this.order!.parts.find((p) =>
			p.includedSubarticleIds.some((id) => id === position.articleId)
		);
		return parentPosition !== undefined;
	}

	private setNewQuantity(position: any, newQuantity: number) {
		if (!newQuantity || isNaN(newQuantity)) {
			return;
		}

		if (position.menge == 0 && position.includedSubarticleIds.length > 0) {
			// Wir kennen den Faktor nicht mehr.
			this.$store.commit(
				"setSnackbarErrorText",
				"Einmal stornierte Positionen können nicht mehr aktiviert werden."
			);
			return;
		}

		if (position.includedSubarticleIds) {
			for (const subarticleId of position.includedSubarticleIds) {
				const factor = newQuantity / position.menge;
				var subPosition: any = this.order!.parts.find((p) => p.articleId === subarticleId);
				if (subPosition) {
					subPosition.changed = true;
					subPosition.menge = subPosition.menge * factor;
				}
			}
		}
		position.menge = newQuantity;
		this.hasChanges = true;
		position.changed = true;
	}

	private get priceModelKeys() {
		// Filter "Express" because it's not in use
		return Object.keys(PriceModel).filter((key: any) => isNaN(Number(key)) && key != "Express");
	}

	private get orderIsCompleted() {
		if (!this.order) return false;
		// 70 = Abgeschlossen, 80 = Storniert, 900 = InStornierung
		return [70, 80, 900].includes(this.order.customerOrderState);
	}

	private async loadOrder() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`CustomerOrder/GetCompleteCustomerOrderById?customerOrderId=${this.orderId}`
			);
			this.order = response.data;
		} catch {
			console.error("Load order failed.");
		} finally {
			this.loading = false;
		}
	}

	private async addArticle() {
		// check if this article is already in the order
		if (
			this.getPartsAndPositions().some((p: any) => p.articleId == this.selectedArticle) ||
			this.getPartsAndPositions().some((p: any) => p.articlelId == this.selectedArticle)
		) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Dieser Artikel ist bereits im Auftrag enthalten."
			);
		} else {
			this.hasChanges = true;
			var dummy = new CustomerOrderPositionDto();
			//@ts-ignore
			dummy.changed = true;
			//@ts-ignore
			dummy.articleId = this.selectedArticle;
			dummy.articlelId = this.selectedArticle;
			dummy.description = "folgt beim Speichern";
			dummy.menge = this.menge;
			if (this.price != "") {
				dummy.customerPricePerPart = parseFloat(this.price);
			}
			//@ts-ignore
			this.order.positions.push(dummy);
		}
		this.articleFilter = "";
		this.menge = 1;
		this.selectedArticle = "";
		this.addDialog = false;
	}

	@Watch("articleFilter")
	private async loadArticle() {
		try {
			this.loading = true;
			const response = await httpClient().get(
				"Article/GetArticles?" +
					`searchTerm=${this.articleFilter}&` +
					"customerId=0&" +
					"from=0&" +
					"to=20&" +
					"onlyLocked=false&" +
					"sorting=3&" + // Sorting ist hardcoded bis jetzt (LastChangeDescending = 3)
					"includeSubarticles=true"
			); // Hier stehen Subartikel von Baugruppen auch zur Auswahl
			for (const iterator of response.data) {
				iterator.text = iterator.articleId + " | " + iterator.customerArticleName;
			}

			const generalArticleResponse = await httpClient().get(
				"Article/GetGeneralArticles?" + `searchTerm=${this.articleFilter}`
			);
			for (const iterator of generalArticleResponse.data) {
				iterator.text = iterator.id + " | " + iterator.name;
				iterator.articleId = iterator.id;
				iterator.customerArticleName = iterator.name;
			}
			this.gefilterteArtikel = response.data.concat(generalArticleResponse.data);
		} catch {
			console.log("Load article failed.");
		} finally {
			this.loading = false;
		}
	}

	private async savePositions() {
		try {
			this.loading = true;
			var changedPositions = this.getPartsAndPositions().filter((p: any) => p.changed);
			for (const position of changedPositions) {
				var articleId = position.articleId;
				let positionDto = new CustomerOrderPositionDto();
				positionDto.articlelId = articleId;
				positionDto.menge = position.menge;
				positionDto.customerPricePerPart = position.customerPricePerPart;

				const response = await httpClient().post(
					`CustomerOrder/CreateOrUpdatePosition?orderId=${this.orderId}`,
					positionDto
				);
				position.changed = false;
			}
			await this.recalculate();
			if (this.order) {
				// Not waiting for this to finish as it's happening in the fertigerportal.
				httpClient().post(
					`CustomerOrder/RefreshOrdersInFertigerportal?fertigerId=${this.order.fertigerId}`
				);
			}
			this.back();
		} catch {
			console.log("Save order failed.");
		} finally {
			this.loading = false;
		}
	}

	private async setPriceModel() {
		if (!this.order) return;
		// Only do something if the current model is different to the order model
		if (this.order.priceModel == PriceModel[this.selectedPriceModel as keyof typeof PriceModel])
			return;

		this.order.priceModel = PriceModel[this.selectedPriceModel as keyof typeof PriceModel];
		try {
			this.loading = true;
			this.priceInfoUpdateInfo = "Preismodell wird aktualisiert...";
			await httpClient().post(
				`CustomerOrder/SetPriceModel?orderId=${this.orderId}&priceModel=${this.order.priceModel}`
			);
			this.priceInfoUpdateInfo = "Auftrag wird neu kalkuliert...";
			await this.recalculate();
		} catch {
			console.log("Setting new price model failed");
			this.$store.commit("setSnackbarText", "Fehler beim Setzen des neuen Preismodells.");
		} finally {
			this.loading = false;
			this.priceInfoUpdateInfo = "";
		}
	}

	private async recalculate() {
		try {
			if (this.order == null) {
				return;
			}
			this.$store.commit("setSnackbarText", "Auftrag wird neu geschachtelt und kalkuliert.");
			this.loading = true;
			const response = await httpClient().post(
				`CustomerOrder/Recalculate?orderId=${this.order.orderId}`
			);
			this.order = response.data;
		} catch {
			console.log("Calculation of order failed.");
		} finally {
			this.loading = false;
		}
	}

	private async updateKommissionsNummer() {
		try {
			if (this.order == null || this.loading || this.loadingKommission) {
				return;
			}
			this.loadingKommission = true;
			await httpClient().post(
				`CustomerOrder/UpdateKommissionsNummer?orderId=${this.order.orderId}&kommissionsNummer=${this.order.kommissionsNummer}`
			);
			this.$store.commit("setSnackbarText", "Kommissionsnummer erfolgreich angepasst.");
		} catch {
			console.log("Update of KommissionsNummer failed.");
			this.$store.commit(
				"setSnackbarErrorText",
				"Anpassung der Kommissionsnummer fehlgeschlagen."
			);
		} finally {
			this.loadingKommission = false;
		}
	}

	private back() {
		this.$router.go(-1);
	}
	/**
	 * Fits the parts and other positions to one list
	 */
	private getPartsAndPositions() {
		if (!this.order) return [];
		return (this.order.parts as any).concat(this.order.positions);
	}

	private getCurrentDate() {
		return Date.now().toString();
	}

	private getPositionNumber(position: PartDto) {
		if (!this.order) {
			return;
		}
		var parentPosition = this.order.parts.find((p) =>
			p.includedSubarticleIds.some((id) => id === position.articleId)
		);
		if (parentPosition !== undefined) {
			return `${parentPosition.position}.${position.position}`;
		}
		return position.position;
	}
}
